import { createElementBlock as e, openBlock as o, createElementVNode as a } from "vue";
import l from "./index289.js";
const r = {}, n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function s(c, t, m, p, i, f) {
  return o(), e("svg", n, t[0] || (t[0] = [
    a("path", {
      fill: "currentColor",
      d: "M18.5 4.25a3.25 3.25 0 0 1 3.25 3.25v9a3.25 3.25 0 0 1-3.25 3.25h-13a3.25 3.25 0 0 1-3.25-3.25v-9A3.25 3.25 0 0 1 5.5 4.25Zm0 1.5h-13A1.75 1.75 0 0 0 3.75 7.5v9c0 .966.784 1.75 1.75 1.75h.147l3.315-3.977a1.75 1.75 0 0 1 2.303-.344l.134.097 1.299 1.039c.09.072.215.072.304.008l.048-.047 2.572-3.215a1.751 1.751 0 0 1 2.332-.367l.129.094 2.167 1.735V7.5a1.75 1.75 0 0 0-1.606-1.744L18.5 5.75Zm-1.658 6.952-.048.047-2.572 3.215a1.75 1.75 0 0 1-2.331.367l-.13-.094-1.299-1.04a.25.25 0 0 0-.299-.009l-.049.045-2.513 3.017H18.5a1.75 1.75 0 0 0 1.744-1.606l.006-.144v-1.307l-3.105-2.483a.25.25 0 0 0-.303-.008ZM9.091 7.91a2.25 2.25 0 1 1-3.182 3.182 2.25 2.25 0 0 1 3.182-3.182ZM6.97 8.969a.75.75 0 1 0 1.133.085L8.03 8.97l-.084-.073a.75.75 0 0 0-.976.073Z"
    }, null, -1)
  ]));
}
const v = /* @__PURE__ */ l(r, [["render", s]]);
export {
  v as default
};
